var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{on:{"click":function($event){return _vm.loadWhatsapp()}}},[_c('img',{attrs:{"src":require("../assets/whatsapp.svg"),"width":"40"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }